"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DiscoveryMethodFields = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _fields = require("../../fields");

var _discoveryMethodConfig = require("./discoveryMethodConfig");

var _selectConfigWithAdditionalItems = _interopRequireDefault(require("../../utils/selectConfigWithAdditionalItems"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var DiscoveryMethodDefinition = _flowRuntime["default"].tdz(function () {
  return _discoveryMethodConfig.DiscoveryMethodDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("queryParams", _flowRuntime["default"].object()), _flowRuntime["default"].property("reasonOption", _flowRuntime["default"].string()), _flowRuntime["default"].property("resetFields", _flowRuntime["default"]["function"](_flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("setReason", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("setSchool", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].string()), _flowRuntime["default"]["return"](_flowRuntime["default"]["void"]()))), _flowRuntime["default"].property("discoveryMethod", _flowRuntime["default"].ref(DiscoveryMethodDefinition))));

var DiscoveryMethodFields = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DiscoveryMethodFields, _React$Component);

  var _super = (0, _createSuper2["default"])(DiscoveryMethodFields);

  function DiscoveryMethodFields() {
    var _this;

    (0, _classCallCheck2["default"])(this, DiscoveryMethodFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleChange = function () {
      var resetFields = _this.props.resetFields;
      resetFields();
    };

    return _this;
  }

  (0, _createClass2["default"])(DiscoveryMethodFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          queryParams = _this$props.queryParams,
          setReason = _this$props.setReason,
          setSchool = _this$props.setSchool;

      if (queryParams) {
        if (queryParams.ref) {
          var reasonString = queryParams.ref;
          setReason(reasonString);
        }

        if (queryParams.school) {
          var schoolString = queryParams.school;
          setSchool(schoolString);
        }

        if (queryParams.ev && queryParams.sm) {
          setReason('Event');
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          discoveryMethod = _this$props2.discoveryMethod,
          queryParams = _this$props2.queryParams,
          reasonOption = _this$props2.reasonOption;
      return queryParams && !queryParams.ref && !queryParams.ev && !queryParams.sm ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_fields.Select, {
        key: _discoveryMethodConfig.discoveryMethodSelect.key,
        id: _discoveryMethodConfig.discoveryMethodSelect.key,
        select: (0, _selectConfigWithAdditionalItems["default"])(_discoveryMethodConfig.discoveryMethodSelect, _discoveryMethodConfig.discoveryMethodItems, discoveryMethod.items),
        onChange: this.handleChange
      }), reasonOption === 'Patient Appeal' && /*#__PURE__*/_react["default"].createElement(_fields.Select, {
        key: _discoveryMethodConfig.patientAppealSelect.key,
        id: _discoveryMethodConfig.patientAppealSelect.key,
        select: (0, _selectConfigWithAdditionalItems["default"])(_discoveryMethodConfig.patientAppealSelect, _discoveryMethodConfig.patientAppealItems, discoveryMethod.appealItems)
      }), reasonOption === 'R & Be talk from ASSET' && /*#__PURE__*/_react["default"].createElement(_fields.Select, {
        key: _discoveryMethodConfig.schoolSelect.key,
        id: _discoveryMethodConfig.schoolSelect.key,
        select: (0, _selectConfigWithAdditionalItems["default"])(_discoveryMethodConfig.schoolSelect, _discoveryMethodConfig.schoolItems, discoveryMethod.schoolItems)
      })) : null;
    }
  }]);
  return DiscoveryMethodFields;
}(_react["default"].Component);

exports.DiscoveryMethodFields = DiscoveryMethodFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var componentKey = ownProps.componentKey;
  return {
    reasonOption: selector(state, "".concat(componentKey, ".reason"))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var componentKey = ownProps.componentKey;
  var reasonPath = "".concat(componentKey, ".reason");
  var patientAppealPath = "".concat(componentKey, ".patientAppeal");
  var schoolPath = "".concat(componentKey, ".school");
  var fields = [reasonPath, patientAppealPath, schoolPath];
  return {
    setReason: function setReason(refString) {
      return dispatch((0, _reduxForm.change)('form', reasonPath, refString));
    },
    setSchool: function setSchool(schoolString) {
      return dispatch((0, _reduxForm.change)('form', schoolPath, schoolString));
    },
    resetFields: function resetFields() {
      Promise.all([dispatch((0, _reduxForm.change)('form', reasonPath, '')), dispatch((0, _reduxForm.change)('form', patientAppealPath, '')), dispatch((0, _reduxForm.change)('form', schoolPath, '')), dispatch(_reduxForm.untouch.apply(void 0, ['form'].concat(fields)))]);
    }
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DiscoveryMethodFields);

exports["default"] = _default;